import { baseGrid } from '@helpers/grid';
import { Device, from, until } from '@helpers/media';
import { contentStyles } from '@helpers/typography';
import { CtaCardStyles } from '@stories/Components/Cards/CtaCard/CtaCard.styles';
import Controls from '@stories/Components/Carousels/Carousel/Controls/Controls';
import MotionTrack from '@stories/Components/Carousels/Carousel/MotionTrack/MotionTrack';
import FullWidthCarouselStyles from '@stories/Components/Carousels/FullWidthCarousel/FullWidthCarousel.styles';
import SectionWrapper from '@stories/Components/Global/SectionWrapper/SectionWrapper';
import SectionWrapperStyles from '@stories/Components/Global/SectionWrapper/SectionWrapper.styles';
import styled from 'styled-components';
const CardsContainer = styled(FullWidthCarouselStyles.Container) `
  margin-top: 0;
  margin-bottom: 0;
`;
const ContentContainer = styled(SectionWrapper) `
  ${SectionWrapperStyles.Inner} {
    padding-bottom: 0;
  }

  + ${CardsContainer} {
    @media ${from(Device.Tablet)} {
      --sectionSpacingTop: 60px;
    }
  }
`;
const Content = styled.div `
  ${contentStyles};
`;
const Track = styled(MotionTrack) `
  &[data-mobile-only='true'] {
    @media ${from(Device.TabletSmall)} {
      ${baseGrid};
      grid-template-columns: repeat(2, 1fr);
      gap: 16px;
    }

    @media ${from(Device.Tablet)} {
      grid-template-columns: repeat(3, 1fr);
    }

    ${CardsContainer}[data-page-type='content'] & {
      gap: 36px;

      ${CtaCardStyles.Container} {
        img {
          max-width: none;
          width: 100%;
          height: auto;
        }
      }
    }
  }
`;
const Item = styled.li `
  flex: 0 0 100%;
  padding-right: 20px;

  /* Required to ensure that item stays visible while carousel animates */
  transition: visibility 0.5s ease;
  @media ${until(Device.TabletSmall)} {
    &[data-active-item='false'] {
      visibility: hidden;
    }
  }

  @media ${from(Device.TabletSmall)} {
    padding: 0;
  }
`;
const PaginationWrapper = styled.div `
  margin: 2rem 0 0;
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 0.5rem;
  align-items: center;

  @media ${from(Device.TabletSmall)} {
    display: none;
  }
`;
const Pagination = styled.div `
  grid-column: 3 / span 8;
`;
const StyledControls = styled(Controls) `
  grid-column: 10 / span 3;
  justify-self: end;
  display: flex;
  gap: 0.5rem;

  @media ${from(Device.Tablet)} {
    grid-column: 11 / span 2;
  }
`;
const Button = styled.button `
  ${FullWidthCarouselStyles.Button};
`;
export const RelatedCardsStyles = {
    Button,
    CardsContainer,
    Content,
    ContentContainer,
    Item,
    Pagination,
    PaginationWrapper,
    StyledControls,
    Track,
};
